import React from 'react';
import { servicesData } from '../../data/Data';
import { FiArrowRight } from 'react-icons/fi';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Services = () => {
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.1,
    });

    // Animation variants
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.15,
                delayChildren: 0.2,
            },
        },
    };

    const cardVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                type: "spring",
                stiffness: 100,
                damping: 12,
            },
        },
    };

    const iconVariants = {
        hidden: { scale: 0, opacity: 0 },
        visible: {
            scale: 1,
            opacity: 1,
            transition: {
                type: "spring",
                stiffness: 300,
                damping: 15,
                delay: 0.1,
            },
        },
    };

    return (
        <section id="service" className="bg-bgpalecolor font-basefont py-20 px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    className="text-center mb-16"
                >
                    <h2 className="text-4xl font-bold text-basecolor mb-4">Our Services</h2>
                    <p className="text-gray-600 max-w-2xl mx-auto">
                        Comprehensive solutions to help you navigate the complexities of global business and migration.
                    </p>
                </motion.div>

                <motion.div
                    ref={ref}
                    initial="hidden"
                    animate={inView ? "visible" : "hidden"}
                    variants={containerVariants}
                    className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8  overflow:visible -z-10"
                >
                    {servicesData?.map((service) => (
                        <motion.div
                            key={service.id}
                            variants={cardVariants}
                            whileHover={{
                                y: -10,
                                boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
                                transition: { duration: 0.2 }
                            }}
                            className="bg-white rounded-2xl  shadow-lg flex flex-col h-full transform transition-all duration-300"
                        >
                            <div className="p-8 flex-grow">
                                <motion.div
                                    variants={iconVariants}
                                    className="w-16 h-16 flex items-center justify-center rounded-xl bg-basecolor text-white shadow-md mb-6"
                                >
                                    {service.icon}
                                </motion.div>
                                <h3 className="text-xl font-bold mb-3 text-basecolor">{service.title}</h3>
                                <p className="text-gray-600 mb-6 flex-grow">{service.description}</p>
                            </div>
                            <div className="px-8 pb-8 mt-auto ">
                                <a
                                    href={service.link}
                                    className="group w-full inline-flex items-center justify-between bg-bgpalecolor hover:bg-basecolor text-basecolor hover:text-white font-medium px-6 py-3 rounded-lg transition-all duration-300"
                                >
                                    <span>View Details</span>
                                    <FiArrowRight className="ml-2 transform group-hover:translate-x-1 transition-transform duration-300" />
                                </a>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default Services;
